import * as React from "react";
import ListItem from "@material-ui/core/ListItem/ListItem";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import Collapse from "@material-ui/core/Collapse/Collapse";
import List from "@material-ui/core/List/List";
import { Theme } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import createStyles from "@material-ui/core/styles/createStyles";
import { Icon } from "../../icons/Icon";
import { lighten } from "@material-ui/core/styles/colorManipulator";

const styles = (theme: Theme) =>
  createStyles({
    expansionPanel: {
      flexDirection: "column"
    },
    groupWrapper: {
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(1)
    },
    link: {
      textDecoration: "none"
    },
    nested: {
      paddingLeft: theme.spacing(4)
    },
    title: {
      backgroundColor: lighten(theme.palette.primary.light, 0.9)
    }
  });

type State = {
  expanded: boolean;
};

type Props = {
  label: string;
  children: any;
  classes?: any;
};

class MenuLinkGroup extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      expanded: false
    };
    this.toggleOpen = this.toggleOpen.bind(this);
  }

  toggleOpen() {
    this.setState(prevState => ({
      expanded: !prevState.expanded
    }));
  }

  render() {
    const { label, children, classes } = this.props;
    const expanded = this.state.expanded;
    return (
      <div className={classes.groupWrapper}>
        <ListItem
          className={classes.title}
          data-test-control={label}
          onClick={this.toggleOpen}
        >
          <ListItemText
            primary={label}
            primaryTypographyProps={{
              variant: "body2"
            }}
          />
          {expanded ? <Icon name="expand_less" /> : <Icon name="expand_more" />}
        </ListItem>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <List disablePadding>{children}</List>
        </Collapse>
      </div>
    );
  }
}

export default withStyles(styles)(MenuLinkGroup);
